module.exports = __webpack_public_path__ + "img/사진3.54324a2f.png";